// extracted by mini-css-extract-plugin
module.exports = {"headerStoreLink":"styles_headerStoreLink__1m9w5","black":"styles_black__2GG9x"};